import React from 'react';
import {DMHint} from 'app/components/banner/DMHint';
import {useNative} from 'app/contexts/NativeContext';

const DMHintBlocked = () => {
  const {isNativeApp, openDeviceSettings} = useNative();
  let action = null;
  let text = (
    <>
      Benachrichtigungen für das aktuelle Gerät sind durch Webseiten-Einstellungen blockiert. Wie du die Einstellungen
      ändern kannst, findest du{' '}
      <a
        href='https://support.fupa.net/support/solutions/articles/75000046224-push-benachrichtigungen#Blockierte-Berechtigung%C2%A0'
        target='_blank'>
        hier.
      </a>
    </>
  );

  const handleClick = () => {
    if (isNativeApp) {
      openDeviceSettings.handler();
    }
  };

  if (isNativeApp) {
    action = {label: 'Einstellungen öffnen', action: handleClick};
    text = 'Benachrichtigungen für das aktuelle Gerät sind durch Geräte-Einstellungen blockiert.';
  }

  return <DMHint text={text} action={action} />;
};

export {DMHintBlocked};
